<script>
export default {
  name: 'PoolPrizeIcon.vue',
  props: ["prize"],
  data() {
    return {};
  },
  methods: {},
  mounted() {

  }
};
</script>

<template>
  <div class="icon-wrapper w-100">
    <div class="d-flex align-items-center">
      <div>
        <img class=" mr-1" :src="require('@/assets/imgs/2025/icons/trophy-icon.png')" height="34px" alt="trophy-icon">
      </div>
      <div>
        <h6 class="prize text-nowrap m-0">{{prize}}</h6>
        <h6 class="prize-sub text-nowrap text-uppercase text-white m-0">Prize Pool</h6>
      </div>
    </div>
  </div>
</template>

<style scoped>
.prize{
  font-family: "sqwaredsemi_bold";
  font-size:1rem;
}
.prize-sub{
  font-family: "sqwaredsemi_bold";
  font-size:0.7rem;
}
</style>
